export const selectCapacityData = state => state.towers.capacity;
export const selectTowersNoBu = state => state?.towers?.towersNoBu;
